/**
 * We need a text format of the given timestamp in german
 */
export const convertTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    const defaultOptions: Intl.DateTimeFormatOptions = {
        timeZone: 'Europe/Berlin',
    };
    const dayDate = date.toLocaleDateString('de-DE', {
        ...defaultOptions,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
    const timeDate = date.toLocaleTimeString('de-DE', {
        ...defaultOptions,
        hour: '2-digit',
        minute: '2-digit',
    });

    return `${dayDate} um ${timeDate}`;
};
